import type { AppLanguage } from "./config";
import { translateStaticText } from "./messages";

export type ContentKind =
  | "user-content"
  | "backend-content"
  | "imported-content"
  | "identifier"
  | "typed-value";

export type LiteralContentKind = ContentKind;

export function preserveLiteralText(
  value: string | null | undefined,
  fallback = "",
): string {
  return value ?? fallback;
}

export function translateSystemEnumLabel<T extends string>(
  value: T,
  labels: Partial<Record<T, string>>,
  language?: AppLanguage,
): string {
  const controlledLabel = labels[value];
  return controlledLabel ? translateStaticText(controlledLabel, language) : value;
}
